import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneNotification,
  GET_ONE_NOTIFICATION,
  GET_ONE_NOTIFICATION_ERROR,
  GET_ONE_NOTIFICATION_SUCCESS,
} from '../types/notification/get-one'

import {
  GetAllNotifications,
  GET_ALL_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS_ERROR,
  GET_ALL_NOTIFICATIONS_SUCCESS,
} from '../types/notification/get-all'

import {
  NewNotification,
  NEW_NOTIFICATION,
  NEW_NOTIFICATION_ERROR,
  NEW_NOTIFICATION_SUCCESS,
} from '../types/notification/new'

import {
  EditNotification,
  EDIT_NOTIFICATION,
  EDIT_NOTIFICATION_ERROR,
  EDIT_NOTIFICATION_SUCCESS,
} from '../types/notification/edit'

import {
  DeleteNotification,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_ERROR,
  DELETE_NOTIFICATION_SUCCESS,
} from '../types/notification/delete'

import {
  GetNotificationsMetrics,
  GET_NOTIFICATIONS_METRICS,
  GET_NOTIFICATIONS_METRICS_ERROR,
  GET_NOTIFICATIONS_METRICS_SUCCESS,
} from '../types/notification/get-metrics'

const currentAllNotificationsStore = ({ notificationStore }) => notificationStore.all.data

function* getOneNotification({ payload }) {
  try {
    const { response, error } = yield call(services.notification.getOne, payload)

    if (error) {
      yield put({
        type: GET_ONE_NOTIFICATION_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_NOTIFICATION_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_NOTIFICATION_ERROR,
      payload: 'Error al obtener una inspeccion',
    })
  }
}

function* getAllNotifications({ payload }) {
  try {
    const { response, error } = yield call(services.notification.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_NOTIFICATIONS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ALL_NOTIFICATIONS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_NOTIFICATIONS_ERROR,
      payload: 'Error al obtener todas las inspecciones',
    })
  }
}

function* newNotification({ payload }) {
  try {
    const { response, error } = yield call(services.notification.new, payload)
    if (error) {
      yield put({
        type: NEW_NOTIFICATION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllNotifications = yield select(currentAllNotificationsStore);

      // Crear una nueva copia del estado
      const newNotificationAdded = currentAllNotifications?.data.map(item => {
        if (item?._id === response?.customer?._id) {
          return {
            ...item,
            notifications: [...item.notifications, response]
          };
        }
        return item;
      })

      yield all([
        put({
          type: NEW_NOTIFICATION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_NOTIFICATIONS_SUCCESS,
          payload: { ...currentAllNotifications, data: newNotificationAdded },
        }),
      ])
    }
  } catch {
    yield put({
      type: NEW_NOTIFICATION_ERROR,
      payload: 'Error al crear una nueva notificacion',
    })
  }
}

function* editNotification({ payload }) {
  try {
    const { response, error } = yield call(services.notification.edit, payload)
    if (error) {
      yield put({
        type: EDIT_NOTIFICATION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllNotifications = yield select(currentAllNotificationsStore);

      // Crear una nueva copia del estado
      const editedNotificationList = currentAllNotifications?.data.map(item => {
        if (item?._id === response?._id) {
          return response;
        }
        return item;
      })

      yield all([
        put({
          type: EDIT_NOTIFICATION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_NOTIFICATIONS_SUCCESS,
          payload: { ...currentAllNotifications, data: editedNotificationList },
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_NOTIFICATION_ERROR,
      payload: 'Error al editar una inspeccion',
    })
  }
}

function* deleteNotification({ payload }) {
  try {
    const { response, error } = yield call(services.notification.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_NOTIFICATION_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllNotifications = yield select(currentAllNotificationsStore);

      // Crear una nueva copia del estado
      const newNotificationAdded = currentAllNotifications?.data.filter(item => item?._id !== payload?.idNotification)

      yield all([
        put({
          type: DELETE_NOTIFICATION_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_NOTIFICATIONS_SUCCESS,
          payload: { ...currentAllNotifications, data: newNotificationAdded },
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_NOTIFICATION_ERROR,
      payload: 'Error al eliminar una inspeccion',
    })
  }
}

function* getMetrics({ payload }) {
  try {
    const { response, error } = yield call(services.notification.getMetrics, payload)
    if (error) {
      yield put({
        type: GET_NOTIFICATIONS_METRICS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_NOTIFICATIONS_METRICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_NOTIFICATIONS_METRICS_ERROR,
      payload: 'Error al obtener metricas de las notificaciones',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneNotification>(GET_ONE_NOTIFICATION, getOneNotification)
  yield takeLatest<GetAllNotifications>(GET_ALL_NOTIFICATIONS, getAllNotifications)
  yield takeLatest<NewNotification>(NEW_NOTIFICATION, newNotification)
  yield takeLatest<EditNotification>(EDIT_NOTIFICATION, editNotification)
  yield takeLatest<DeleteNotification>(DELETE_NOTIFICATION, deleteNotification)
  yield takeLatest<GetNotificationsMetrics>(GET_NOTIFICATIONS_METRICS, getMetrics)
}
